export function objectToUrlEncodedString(parameters: {[key: string]: string}): string {
    return Object.keys(parameters)
    .reduce(
        (acc, key) => {
            acc.append(key, parameters[key]);
            return acc;
        },
        new URLSearchParams()
    )
    .toString();
}
